import { Card, CardHeader, CardBody } from 'reactstrap'
import AppObjectFieldTable from '../AppObjectFieldTable/AppObjectFieldTable'
import './AppObjectCard.css'

export default function AppObjectCard(props) {
  const { object, parentObjectId, action, formInputs, tab } = props
  console.log(`AppObjectCard rendered tab: ${tab.name}`, props)

  return (
    <Card className="app-object-card">
      <CardHeader className="app-object-card-header">{tab.name}</CardHeader>
      <CardBody className="app-object-card-body">
        <AppObjectFieldTable object={object} parentObjectId={parentObjectId} action={action} formInputs={formInputs} tab={tab} />
      </CardBody>
    </Card>
  )
}